module.exports = __webpack_public_path__ + "img/主页图片2.e0972f82.png";